import { FieldValues, UseControllerProps, useWatch } from 'react-hook-form';

import dayjs from 'dayjs';

import { DatePickerControl } from '../DatePickerControl';
import { IDatePickerControlProps } from '../DatePickerControl/types';

interface IDatePickerToProps extends IDatePickerControlProps {
  fieldNameFrom: string;
}

export const DatePickerTo = <T extends FieldValues>(props: UseControllerProps<T> & IDatePickerToProps) => {
  const { fieldNameFrom, ...restProps } = props;

  const minDate = useWatch({ name: fieldNameFrom });

  return <DatePickerControl {...restProps} minDate={dayjs(minDate)} />;
};
